export interface RouteStorageSyncInput {
  routeInstallationId?: number
  routeStorageId?: string
  activeInstallation?: number
  activeStorage?: string
}

export interface RouteStorageSyncResult {
  /** When set, dispatch setActiveInstallation(installationId, storageId). */
  installationToActivate?: { installationId: number; storageId: string | null }
  /** When set, dispatch setActiveStorage(storageId). */
  storageToActivate?: string
}

/**
 * Determines how the active installation/storage store should be synced with the current route.
 *
 * The active storage is only cleared when switching to a different installation without a storage
 * segment. Same-installation routes that omit the optional storage segment (e.g. vehicle-integration)
 * keep the active storage, so storage-gated navigation items are not falsely disabled.
 */
export const resolveActiveInstallationSync = ({
  routeInstallationId,
  routeStorageId,
  activeInstallation,
  activeStorage,
}: RouteStorageSyncInput): RouteStorageSyncResult => {
  const result: RouteStorageSyncResult = {}

  if (routeInstallationId !== undefined && Number.isFinite(routeInstallationId) && routeInstallationId !== activeInstallation) {
    result.installationToActivate = { installationId: routeInstallationId, storageId: routeStorageId ?? null }
  }

  if (routeStorageId !== undefined && routeStorageId !== activeStorage) {
    result.storageToActivate = routeStorageId
  }

  return result
}
